import { Controller } from "stimulus"

export default class extends Controller {
  toggle(ev) {
    const check = $(ev.currentTarget).find("input")[0]

    if (check.checked) {
      ev.currentTarget.classList.remove("active")
      check.checked = false
    } else {
      ev.currentTarget.classList.add("active")
      check.checked = true
    }
  }
}
